if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (!this.form) return;

        const variantInput = this.form.querySelector("[name=id]");
        if (variantInput) variantInput.disabled = false;

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitting = false;

        if (this.submitButton && document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      setSubmitting(isSubmitting) {
        this.submitting = isSubmitting;
        window.__cartAddBusy = isSubmitting;

        if (!this.submitButton) return;

        if (isSubmitting) {
          this.submitButton.setAttribute("aria-disabled", "true");
          this.submitButton.classList.add("loading");
          document.querySelectorAll(".sticky-atc__button").forEach((btn) => {
            btn.disabled = true;
            btn.setAttribute("aria-busy", "true");
          });
        } else {
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
          document.querySelectorAll(".sticky-atc__button").forEach((btn) => {
            btn.removeAttribute("aria-busy");
            if (btn.dataset.forceDisabled !== "true") btn.disabled = false;
          });
        }

        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.toggle("hidden", !isSubmitting);
      }

      getCooldownSecondsLeft() {
        const until = window.__cartRateLimitUntil || 0;
        return Math.max(0, Math.ceil((until - Date.now()) / 1000));
      }

      startRateLimitCooldown(ms) {
        window.__cartRateLimitUntil = Date.now() + ms;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (!this.submitButton) return;
        if (this.submitting || window.__cartAddBusy) return;
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const cooldownLeft = this.getCooldownSecondsLeft();
        if (cooldownLeft > 0) {
          this.handleErrorMessage(
            `Please wait ${cooldownLeft}s before adding to cart again.`,
          );
          return;
        }

        this.error = false;
        this.handleErrorMessage();
        this.setSubmitting(true);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);

          // Never retry 429 — retries make Shopify rate-limit worse.
          if (response.status === 429) {
            this.startRateLimitCooldown(45000);
            throw new Error("rate-limit");
          }

          let data;
          try {
            data = await response.json();
          } catch (parseError) {
            throw new Error(
              response.ok ? "invalid-json" : `cart-add-${response.status}`,
            );
          }

          if (!response.ok || data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: data.errors || data.description,
              message: data.message,
            });
            this.handleErrorMessage(
              data.description ||
                data.message ||
                window.cartStrings?.error ||
                "Unable to add to cart",
            );

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (soldOutMessage) {
              this.submitButton.setAttribute("aria-disabled", "true");
              const label = this.submitButton.querySelector("span");
              if (label) label.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
            }
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const bundleDiscountCode = (
            formData.get("_bundle_discount_code") || ""
          )
            .toString()
            .trim();
          if (bundleDiscountCode) {
            const redirectTarget = `${window.location.pathname}${window.location.search}`;
            window.location.href = `/discount/${encodeURIComponent(
              bundleDiscountCode,
            )}?redirect=${encodeURIComponent(redirectTarget)}`;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: data,
          });

          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(data);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(data);
          }

          this.handleErrorMessage();
        } catch (e) {
          console.error(e);
          if (e && e.message === "rate-limit") {
            const seconds = this.getCooldownSecondsLeft() || 45;
            this.handleErrorMessage(
              `Too many cart updates. Please wait ${seconds}s and try again.`,
            );
          } else {
            this.handleErrorMessage(
              window.cartStrings?.error || "Unable to add to cart",
            );
          }
        } finally {
          if (this.cart && this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }
          this.setSubmitting(false);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
